import React, { useState, useEffect } from 'react';

import EmptyList from '../useful/EmptyList';
import { withAuthorization } from '../session';
import ClassificationTableItem from './ClassificationTableItem';
import { orderTeams } from '../TeamList/TeamsUtil'

const ClassificationTable = (props) => {

    const { teams } = props;

    const [sortedTeams, setSortedTeams] = useState([])

    useEffect(() => {
        const st = orderTeams(teams);
        setSortedTeams(st);
    }, [teams])

    const tableHead =
        <thead >
            <tr>
                <th className="align-middle text-center" style={{ width: '15px' }} ></th>
                <th className="" style={{ width: 40 }}></th>
                <th className="pl-0" >NOMBRE</th>
                <th className="text-center" style={{ width: 25 }}>J</th>
                <th className="text-center" style={{ width: 25 }}>G:P:E</th>
                {/* <th className="text-center" style={{ width: 25 }}>G</th>
                <th className="text-center" style={{ width: 25 }}>P</th>
                <th className="text-center" style={{ width: 25 }}>E</th> */}
                <th className="text-center d-none d-sm-table-cell" style={{ width: 30 }}>Goles</th>
                <th className="text-center d-none d-sm-table-cell" style={{ width: 25 }}>DG</th>
                <th className="text-center" style={{ width: 25 }}>Pts</th>
            </tr>
        </thead>

    const listView = (sortedTeams && sortedTeams.length > 0) ?
        sortedTeams.map((team, i) => {
            if (team)
                return (
                    <ClassificationTableItem key={i} team={team} index={i + 1} />
                )
        })
        :
        <tr>
            <td colSpan="10"><EmptyList /></td>
        </tr>

    return (
        <>
            <div className="table-responsive-sm">
                <table className="table table-sm table-hover small mb-1">
                    {tableHead}
                    <tbody>
                        {listView}
                    </tbody>
                </table>
            </div>
            <div className="row m-0 small font-italic text-secondary">
                <span className="col-auto pl-0 pr-3 small"> <strong>J: </strong>Partidos Gugados</span>
                <span className="col-auto pl-0 pr-3 small"> <strong>G: </strong>Partidos Ganados</span>
                <span className="col-auto pl-0 pr-3 small"> <strong>P: </strong>Partidos Perdidos</span>
                <span className="col-auto pl-0 pr-3 small"> <strong>E: </strong>Partidos Empatados</span>
                <span className="col-auto pl-0 pr-3 small d-none d-sm-table-cell"> <strong>Goles: </strong>Goles a Favor y en Contra</span>
                <span className="col-auto pl-0 pr-3 small d-none d-sm-table-cell"> <strong>DG: </strong>Diferencia de Goles</span>
                <span className="col-auto pl-0 pr-3 small"> <strong>Pts: </strong>Puntos</span>
            </div>
        </>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(ClassificationTable);